module.exports = __webpack_public_path__ + "img/stick_hebergements_hotel.b96a3411.svg";